import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  fieldErrorsForPrefix,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import {
  useVbsOrderShowQuery,
  useVbsOrderUpdatePostalAddressMutation,
  useVbsOrderUpdateRepresentativeMutation,
  useVbsOrderUpdateServiceAddressMutation,
  useVbsOrderUpdateServiceContactMutation,
} from "@/services/backend/vbs/orders/api/order-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";

export function AddressesAndContactsRoute() {
  const { orderId } = useParams();
  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();
  const {
    data: order,
    isLoading,
    error,
  } = useVbsOrderShowQuery({
    id: orderId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={order!.id}
        address={order!.postalAddress}
        mutation={useVbsOrderUpdatePostalAddressMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "postalAddress.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`postalAddress.${field}`)
        }
      />
      <ServiceAddressCardWithMutation
        id={order!.id}
        address={order!.serviceAddress}
        mutation={useVbsOrderUpdateServiceAddressMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "serviceAddress.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`serviceAddress.${field}`)
        }
      />
      <ContactCardWithMutation
        id={order!.id}
        contact={order!.serviceContact}
        mutation={useVbsOrderUpdateServiceContactMutation}
      />
      <RepresentativeCardWithMutation
        id={order!.id}
        representative={order!.representative}
        mutation={useVbsOrderUpdateRepresentativeMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "representative.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`representative.${field}`)
        }
      />
    </div>
  );
}
